import React, { useState } from "react";
import SunkenPanel from "../components/SunkenPanel";
import { useOpenPage } from "../components/WindowManager";

const ITEMS = [
  { name: "About Me.doc", path: "/about" },
  { name: "Projects.doc", path: "/projects" },
  { name: "Reading.doc", path: "/reading" },
  { name: "Contact.doc", path: "/contact" },
];

const Documents = () => {
  const [selected, setSelected] = useState(null);
  const openPage = useOpenPage();

  return (
    <div className="flex flex-col h-full desktop-font text-xl select-none">
      <div className="flex-1 min-h-0">
        <SunkenPanel>
          <div
            className="flex flex-wrap content-start gap-2 h-full p-2 overflow-auto"
            onPointerDown={(e) => setSelected(e.target.closest("[data-item]")?.dataset.item ?? null)}
          >
            {ITEMS.map(({ name, path }) => {
              const isSelected = selected === name;
              return (
                <div
                  key={name}
                  data-item={name}
                  className="flex flex-col items-center w-[5.5rem] cursor-default"
                  onDoubleClick={() => openPage(path)}
                >
                  <img
                    src="/desktop-icons/document-icon.png"
                    alt=""
                    className="w-8 h-8"
                    draggable={false}
                  />
                  <span
                    className={`mt-1 px-[0.1rem] text-center leading-[0.9] ${
                      isSelected ? "bg-[#000080] text-white" : ""
                    }`}
                  >
                    {name}
                  </span>
                </div>
              );
            })}
          </div>
        </SunkenPanel>
      </div>
      <div className="flex shrink-0 h-6 mt-[0.15rem] px-2 items-center border-[0.1rem] border-t-[#828282] border-l-[#828282] border-b-white border-r-white">
        {ITEMS.length} object(s)
      </div>
    </div>
  );
};

export default Documents;
